import {CommonModule} from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, Type } from "@angular/core";
import {MyOverlayRef} from './myoverlay-ref';

@Component({
  selector: "app-overlay",
  imports: [CommonModule],
  templateUrl: "./overlay.component.html",
  standalone: true,
  styleUrls: ["./overlay.component.scss"],


})
export class OverlayComponent implements OnInit {
  contentType: 'template' | 'string' | 'component' | undefined;
  content: string | TemplateRef<any> | Type<any> | any;
  context: any;

  constructor(private ref: MyOverlayRef) {}

  close() {
    this.ref.close(null);
  }

  ngOnInit() {
    this.content = this.ref.content;

    if (typeof this.content === 'string') {
      this.contentType = 'string';
    } else if (this.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.context = {
        close: this.ref.close.bind(this.ref),
      };
    } else {
      this.contentType = 'component';
    }
  }
}
